import React, { Suspense } from 'react';
import { Routes, Route } from 'react-router-dom';
import { Auth0Provider } from '@app/providers/Auth0Provider';
import { ToastProvider } from '@app/providers/ToastProvider';
import RootLayout from '@app/layout/RootLayout';
import { ProtectedRoute, PublicRoute } from '@shared/components/auth';
import SessionExpiredModal from '@shared/components/SessionExpiredModal';
import { ErrorBoundary } from '@shared/components/ErrorBoundary';
import { PageLoader } from '@shared/components/PageLoader';
import { publicRoutes, protectedRoutes } from './routes';

const App: React.FC = () => {
  return (
    <ErrorBoundary>
      <Auth0Provider>
        <ToastProvider>
          <Suspense fallback={<PageLoader size="md" />}>
            <Routes>
              {/* Public routes */}
              {publicRoutes.map(({ path, component: Component }) => (
                <Route
                  key={path}
                  path={path}
                  element={
                    <PublicRoute>
                      <Component />
                    </PublicRoute>
                  }
                />
              ))}

              {/* Protected routes */}
              <Route element={<ProtectedRoute><RootLayout /></ProtectedRoute>}>
                {protectedRoutes.map(({ path, component: Component }) => (
                  <Route key={path} path={path} element={<Component />} />
                ))}
              </Route>
            </Routes>
          </Suspense>

          {/* Global modals */}
          <SessionExpiredModal />
        </ToastProvider>
      </Auth0Provider>
    </ErrorBoundary>
  );
};

export default App;
